import React, { useEffect } from 'react';
import { Route, RouteObject, Routes, useNavigate } from 'react-router-dom';
import { CssBaseline } from '@mui/material';
import ThemeProvider from './theme/ThemeProvider';
import SideNav from './layout/SidebarLayout';
import routes, { publicRoutes } from './../router';
import { CallbackComponent } from './components/auth/Callback.component';
import { Logout } from './components/auth/Logout';
import { LogoutCallback } from './components/auth/LogoutCallback';
import ProtectedRoute from './utils/ProtectedRoute';
import MainLayoutComponent from './layout/MainLayout.component';
import AdminLoginComponent from './containers/superAdmin/bookingAction/AdminLogin';
// store
import { useAppSelector, useAppDispatch } from './store/stateTypeHook';
import { updateToken } from './store/stateSlice/adminSlice';
// utility
import checkToken from 'src/app/utils/isTokenValid';
import './assets/scss/styles.scss';
// fonts
import './assets/fonts/Objective_Woff2/Objective-Light.woff2';
import './assets/fonts/Objective_Woff2/Objective-Regular.woff2';
import './assets/fonts/Objective_Woff2/Objective-Medium.woff2';
import './assets/fonts/Objective_Woff2/Objective-Bold.woff2';
import './assets/fonts/Objective-ttf/Objective-Light.ttf';
import './assets/fonts/Objective-ttf/Objective-Regular.ttf';
import './assets/fonts/Objective-ttf/Objective-Medium.ttf';

function App() {
    const { user, admin } = useAppSelector((state) => state);
    const { loggedinUser } = user;
    const dispatch = useAppDispatch();
    const navigate = useNavigate();

    const adminTokenExpiryTime = new Date().getTime() + admin.expires_in * 1000 - new Date().getTime();

    useEffect(() => {
        if (loggedinUser.is2FaEnabled) {
            // Function to get cookie by name
            const getCookie = (name) => {
                const cookieArray = document.cookie.split('; ');

                for (let i = 0; i < cookieArray.length; i++) {
                    const cookiePair = cookieArray[i].split('=');

                    if (name === cookiePair[0]) {
                        return decodeURIComponent(cookiePair[1]);
                    }
                }

                return null;
            };

            // Check for 'myCookie'
            const value = getCookie(loggedinUser.userId);
            if (value && loggedinUser.userId === value) {
                return;
            } else {
                navigate('/customer/login-process-2fa');
            }
        }
    }, [loggedinUser, navigate]);

    useEffect(() => {
        const time = setTimeout(() => {
            dispatch(
                updateToken({
                    access_token: '',
                    expires_in: 0,
                })
            );
        }, adminTokenExpiryTime);

        return () => {
            clearTimeout(time);
        };
    }, [admin.expires_in]);

    const publicContent = (routes: RouteObject[]) => {
        return routes.map((route, i) => {
            if (route.children) {
                <Route element={route.element ? route.element : <span></span>} path={route.path} key={i}>
                    {publicContent(route.children)}
                </Route>;
            }
            return <Route path={route.path} element={route.element} key={i} />;
        });
    };

    const content = routes
        .filter((e) => {
            if (loggedinUser && loggedinUser.systemPermissions) {
                return loggedinUser.systemPermissions.indexOf(e.secret) !== -1;
            }
            return e;
        })
        .map((route, index) => {
            if (route.isPrivate) {
                if (!checkToken(admin.expires_in) && route.path === 'super-admin/booking-actions') {
                    return <Route key={index} path='super-admin/*' element={<AdminLoginComponent />} />;
                }
                return (
                    <Route
                        element={<ProtectedRoute>{route.element}</ProtectedRoute>}
                        path={route.path}
                        key={index}
                        children={null}
                    />
                );
            }
            return (
                <Route
                    element={<ProtectedRoute>{route.element}</ProtectedRoute>}
                    path={route.path}
                    key={index}
                    children={null}
                />
            );
        });

    // const adminPages = () => {
    //   if (loggedinUser && loggedinUser.systemPermissions) {
    //     if (checkToken(admin.expires_in)) {
    //       return adminRoutes.map((route, i) => {
    //         if (loggedinUser.systemPermissions.indexOf(route.secret) !== -1) {
    //           return <Route key={i} element={route.element} path={route.path} />
    //         } else {
    //           return null;
    //         }
    //       });
    //     } else {
    //       return <Route path="admin/*" element={<AdminLoginComponent />} />
    //     }
    //   }
    // }

    return (
        <ThemeProvider>
            <SideNav />
            <MainLayoutComponent>
                <Routes>
                    <Route path='/signin-oidc' element={<CallbackComponent />} />
                    <Route path='/signout-oidc' element={<LogoutCallback />} />
                    <Route path='/logout' element={<Logout />} />
                    {content}
                    {publicContent(publicRoutes)}
                    {/* {adminPages()} */}
                </Routes>
            </MainLayoutComponent>
            <CssBaseline />
        </ThemeProvider>
    );
}

export default App;
